import React from 'react';

import { Chip, Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';

import { capitalizeTopic } from '#src/app/shared/utils/topic';

import { useRelatedTopicPages } from './hooks/useRelatedTopicPages';

export const RelatedTopicPages: React.FC = () => {
	const {
		data: { displayed, headingText, relatedTopicPages },
	} = useRelatedTopicPages();

	if (!displayed) {
		return null;
	}

	return (
		<div className="flex flex-col gap-6">
			<Text as="h2" variant="heading" size="small" className="text-typography-strong" data-qa="related-topics-heading">
				{headingText}
			</Text>

			<div className="flex flex-wrap gap-2" data-qa="related-topics">
				{relatedTopicPages.map((topicPage) => (
					<Chip
						size="large"
						key={topicPage.slug}
						data-qa={`related-topic-${topicPage.slug}-chip`}
						as="a"
						href={`/topic/${encodeURIComponent(topicPage.slug)}?source_location=topic_page`}
						trailingIcon={<ArrowRightIcon />}
					>
						{capitalizeTopic(topicPage.name)}
					</Chip>
				))}
			</div>
		</div>
	);
};
